import { render, staticRenderFns } from "./TimelineEventosPosPublicacao.vue?vue&type=template&id=c8fbf2b8"
import script from "./TimelineEventosPosPublicacao.vue?vue&type=script&lang=js"
export * from "./TimelineEventosPosPublicacao.vue?vue&type=script&lang=js"
import style0 from "./TimelineEventosPosPublicacao.vue?vue&type=style&index=0&id=c8fbf2b8&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports